export default __webpack_public_path__ + "static/media/4.aed4a485.jpeg";